import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { TravelExpenseReport } from './TravelExpenseReport';

export const TravelExpenseReportPage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <TravelExpenseReport />
    </PageContainer>
  );
};
